import produce from 'immer'
import { SET_USER_FOUND } from './constants';

export const initialState = {
    users: null
}

const exploreReducer = (state = initialState, action) => 
    produce(state, (draft) => {
        // eslint-disable-next-line default-case
        switch (action.type) {
            case SET_USER_FOUND:
                draft.users = action.data;
                break;
        }
    })


export default exploreReducer;